import { routesBuilder } from '@guiker/shared-framework'

import { Transfer } from '../../../entity'
import { paths } from '../paths'
import { createTransferPayloadSchema } from '../schemas'

const base = routesBuilder<Transfer>()({
  basePath: paths.dynamic.transfer.all.withScope(),
})

const byId = routesBuilder<Transfer>()({
  basePath: paths.constant.transfers.withId.path,
})

export const transferRoutes = {
  createTransfer: base.buildPost({
    payloadSchema: createTransferPayloadSchema,
  }),
  approveTransfer: byId.buildPut({
    path: '/approve',
  }),
}
